import "core-js/modules/es.array.push.js";
import "core-js/modules/es.error.cause.js";
import { computed, getCurrentInstance, onBeforeMount, onMounted, ref, watch } from 'vue';
export default {
  name: 'ComForm',
  props: {
    config: {
      type: Object,
      required: true
    },
    modelValue: {
      type: [Object, null, undefined],
      require: true
    }
  },

  setup(props, {
    emit
  }) {
    /**
     * 组件实例对象
     */
    const {
      proxy: instanceProxy
    } = getCurrentInstance();
    /**
     * data
     */

    let formRules = {};
    const requiredType = new Map([['int', /^[1-9]{1}[0-9]*$/], ['number', /^\d+(\.\d+)?$/], ['money', /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/], ['phone', /^[1][3,4,5,6,7,8,9][0-9]{9}$/], ['mail', /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/]]);
    /**
     * computed
     */

    const fields = computed(() => props.config.fields || []);
    const formData = computed({
      get() {
        return props.modelValue || {};
      },

      set(newValue) {
        emit('update:modelValue', newValue);
      }

    });
    const placeholder = computed(() => props.config.hiddenPlaceholder ? ' ' : '');
    let popupShow = ref({});
    /**
     * 生命周期
     */

    onBeforeMount(() => {
      popupShowInit();
    });
    onMounted(() => {
      initPage();
    });
    /**
     * methods
     */
    // 初始化

    const initPage = () => {// if (Array.isArray(props.config.fields)) defaultValueInit();
    }; // form组件初始化


    const defaultValueInit = (status = false) => {
      const initData = {};
      props.config.fields.forEach(item => {
        const {
          defaultValue,
          name,
          type,
          range,
          valueFormatField
        } = item; // 默认值初始化

        if (item.hasOwnProperty('defaultValue')) {
          initData[name] = defaultValue;

          if ((type === 'date' || type === 'datetime') && range && valueFormatField) {
            initData[valueFormatField[0]] = defaultValue[0];
            initData[valueFormatField[1]] = defaultValue[1];
          }
        }
      }); // 默认值初始化 - 是否强制赋值为默认值（如果是，只接收 field/defaultValue 的值）

      if (status) emit('update:modelValue', initData);else emit('update:modelValue', { ...initData,
        ...props.data
      });
    }; // 校验初始化


    const formRulesInit = value => {
      const newFormRules = {};

      for (let name in value) {
        const rulesItem = value[name];
        newFormRules[name] = [];
        rulesItem.forEach(item => {
          if (item.hasOwnProperty('verifyType')) {
            const verifyType = item.verifyType;
            let verifyRegExp = null;

            if (requiredType.has(verifyType)) {
              verifyRegExp = requiredType.get(verifyType);
            } else if (/number\[\d+(\,|, )\d+?\]/.test(verifyType)) {
              let rangeArr = verifyType.replace(/number\[|\]/g, '').split(',');
              verifyRegExp = eval(`/(^[0-9]{1,${rangeArr[0]}}$)|(^[0-9]{1,${rangeArr[0]}}[\\.]{1}[0-9]{1,${Number(rangeArr[1])}}$)/`);
            } else {
              newFormRules[name].push(item);
              return;
            }

            item.validator = (rule, value, callback) => {
              if (value === '') callback(new Error(rule.message));else if (!verifyRegExp.test(value)) callback(new Error(rule.message));else callback();
            };

            item.trigger = 'blur';
          }

          newFormRules[name].push(item);
        });
      }

      formRules = newFormRules;
    };

    const popupShowInit = () => {
      const configFields = props.config.fields || [];
      configFields.forEach(({
        type,
        name
      }) => {
        if (type === 'phoneCascader') popupShow.value[name] = false;
      });
    }; // 表单校验


    const formVerify = callbackFun => {
      instanceProxy.$refs.form.validate(valid => {
        callbackFun(valid);
      });
    }; // 表单单项校验


    const formValidateField = (name, callbackFun) => {
      instanceProxy.$refs.form.validateField(name, valid => {
        if (callbackFun) callbackFun(valid);
      });
    };
    /**
     * watch
     */


    watch(() => props.config.rules, value => {
      if (value) formRulesInit(value);
    }, {
      immediate: true
    });
    return {
      fields,
      formData,
      formRules,
      popupShow,
      placeholder,
      initPage,
      defaultValueInit,
      formVerify,
      formValidateField
    };
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',

          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }

        }, {
          text: '最近一个月',

          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }

        }, {
          text: '最近三个月',

          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }

        }]
      }
    };
  },

  methods: {
    // 日期和日期时间选择器的快捷键
    pickerOptionsChange(field) {
      if (field.range) {
        let maxDayRangeOptions = {};

        if (field.hasOwnProperty('maxDayRange') && field.maxDayRange > 0) {
          maxDayRangeOptions = {
            onPick: ({
              maxDate,
              minDate
            }) => {
              this.selectDate = minDate.getTime();
              if (maxDate) this.selectDate = '';
            },
            disabledDate: time => {
              if (this.selectDate !== '') {
                const one = (field.maxDayRange - 1) * 24 * 3600 * 1000;
                const minTime = this.selectDate - one;
                const maxTime = this.selectDate + one;
                return time.getTime() < minTime || time.getTime() > maxTime;
              }
            }
          };
        }

        if (field.pickerOptions === true) return { ...maxDayRangeOptions,
          ...this.pickerOptions
        };else if (field.hasOwnProperty('pickerOptions')) return { ...maxDayRangeOptions,
          ...field.pickerOptions
        };else return { ...maxDayRangeOptions
        };
      } else if (field.hasOwnProperty('pickerOptions')) return field.pickerOptions;
    },

    // 日期选择器类型
    datePickerType(type, range) {
      return type === 'date' ? range ? 'daterange' : 'date' : type;
    },

    // form表单通用类型的change时间
    commonChange(val, field) {
      if (field.hasOwnProperty('change')) field.change(val, field);
    },

    // 时间、日期时间类型的change时间
    commonDateChange(val, field) {
      const {
        range,
        valueFormatField
      } = field;

      if (range && valueFormatField) {
        if (val && Array.isArray(val)) {
          this.$props.modelValue[valueFormatField[0]] = val[0];
          this.$props.modelValue[valueFormatField[1]] = val[1];
        } else {
          this.$props.modelValue[valueFormatField[0]] = null;
          this.$props.modelValue[valueFormatField[1]] = null;
        }
      }

      if (field.hasOwnProperty('change')) field.change(val, field);
    },

    // 选择器拉下内容的点击事件
    selectOptionClickChange(item, field) {
      if (field.hasOwnProperty('selectedAllChange')) field.selectedAllChange(item);
    },

    popupShowChange(value, name) {
      this.popupShow[name] = value;
    },

    cascaderChange(val, field, index) {
      let checkedNodes = null;

      if (field.checkedNodes) {
        checkedNodes = this.$refs['cascader' + index][0].getCheckedNodes()[0].pathLabels;
        this.$props.modelValue[field.name + 'Label'] = checkedNodes;
      }

      if (val) this.$refs.form.validateField(field.name);
      if (field.hasOwnProperty('change')) field.change(val, field, checkedNodes);
    },

    phoneCascaderFinish({
      selectedOptions
    }, field) {
      this.popupShow[field.name] = false;
      const labelName = field.fieldNames ? field.fieldNames.text : 'label';
      this.$props.modelValue[field.name + 'label'] = selectedOptions.map(option => option[labelName]).join('/');
      if (field.hasOwnProperty('selectedAllChange')) field.selectedAllChange(selectedOptions);
      if (field.valueInAll) this.$props.modelValue[field.name + 'AllValue'] = selectedOptions;
    }

  }
};